import { allFeatureTypes } from '../../backend/extraTypes';
import { useUserState } from '@juvare/contact-management/ui/hooks';
export function useFeatureFlags() {
    var _a, _b;
    const userState = useUserState();
    const featureFlags = (_b = (_a = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _a === void 0 ? void 0 : _a.featureFlags) !== null && _b !== void 0 ? _b : [];
    return allFeatureTypes.reduce((acc, flag) => {
        acc[flag] = featureFlags.includes(flag);
        return acc;
    }, {});
}
